import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { VehicleBlockingEvent } from "../../../components/FleetManagement/types/FleetManagement.types";
import type { VehicleBookingEventsParams } from "./useRemoteFetchVehicleBookingEvents";

/**
 * Fetches blocking events for a vehicle (GET /fleet/vehicles/:vehicleId/blocking-events).
 * Optional startDate/endDate (YYYY-MM-DD) filter by overlapping range; when omitted, returns all blocking events for the vehicle.
 */
export function useRemoteFetchBlockingEvents(
  params: VehicleBookingEventsParams | null
): UseQueryResult<VehicleBlockingEvent[], RemoteApiError> {
  const enabled = params != null && params.vehicleId != null;

  return useRemoteQuery<VehicleBlockingEvent[], RemoteApiError>({
    queryKey: [
      "fleet",
      "vehicles",
      params?.vehicleId,
      "blocking-events",
      params?.startDate,
      params?.endDate
    ],
    url: `/fleet/vehicles/${params?.vehicleId}/blocking-events`,
    params:
      params != null
        ? {
            ...(params.startDate ? { startDate: params.startDate } : {}),
            ...(params.endDate ? { endDate: params.endDate } : {})
          }
        : undefined,
    enabled
  });
}
